import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5555/api'; // Fixed: include /api like other services

// Create axios instance with auth token
const createAuthenticatedRequest = () => {
    const token = localStorage.getItem('eldai_token');
    return axios.create({
        baseURL: API_BASE_URL,
        headers: {
            'Authorization': token ? `Bearer ${token}` : '',
        }
    });
};

export interface UploadResult {
    filename: string;
    success: boolean;
    message: string;
    productCode?: string;
    s3Url?: string;
}

export interface UploadResponse {
    success: boolean;
    message: string;
    results: UploadResult[];
    summary: {
        total: number;
        success: number;
        failed: number;
    };
}

export const uploadService = {
    // Test S3 connection
    testS3Connection: async (): Promise<{ success: boolean; message: string; bucket?: string; region?: string }> => {
        try {
            const token = localStorage.getItem('eldai_token');
            console.log('Testing S3 connection...');
            console.log('Token available:', !!token);
            console.log('API URL:', API_BASE_URL);
            console.log('Full URL will be:', `${API_BASE_URL}/upload/test-s3`);

            const response = await axios.get(`${API_BASE_URL}/upload/test-s3`, {
                headers: {
                    'Authorization': token ? `Bearer ${token}` : '',
                }
            });
            console.log('S3 test response:', response.data);
            return response.data;
        } catch (error: any) {
            console.error('Erreur test S3:', error);
            console.error('Error status:', error.response?.status);
            console.error('Error data:', error.response?.data);
            return {
                success: false,
                message: error.response?.data?.message || error.response?.data?.error || 'Erreur lors du test de connexion S3'
            };
        }
    },

    // Upload images to S3
    uploadImages: async (files: FileList): Promise<UploadResponse> => {
        try {
            const api = createAuthenticatedRequest();
            const formData = new FormData();

            // Add all files to form data
            for (let i = 0; i < files.length; i++) {
                formData.append('images', files[i]);
            }

            const response = await api.post('/upload/images', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                // Add progress tracking if needed
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.total) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        console.log(`Upload progress: ${percentCompleted}%`);
                    }
                }
            });

            return response.data;
        } catch (error: any) {
            console.error('Erreur upload:', error);

            // Handle specific error cases
            if (error.response?.status === 403) {
                throw new Error('Accès refusé - Droits administrateur requis');
            } else if (error.response?.status === 413) {
                throw new Error('Fichiers trop volumineux');
            } else {
                throw new Error(error.response?.data?.message || 'Erreur lors de l\'upload des images');
            }
        }
    }
};
